import React from 'react';
import { connect } from 'react-redux';
import { ConnectedPropsWithoutDispatch } from '../../../stores/redux-store';
import { resetCredentials as resetCredentialsConnect } from '../../../stores/credentials-store';
import { RiskInsightsMachineView, RiskInsightsMachineViewProps } from './RiskInsightsMachineView';

export type RiskInsightsDirectorProps = PropsFromRedux & {
  MachineView: React.ComponentType<RiskInsightsMachineViewProps>;
};

export const RiskInsightsDirectorPresenter = ({
  resetCredentials,
  MachineView = RiskInsightsMachineView,
}: RiskInsightsDirectorProps) => {
  return <MachineView onCancel={resetCredentials} />;
};

const connector = connect(null, {
  resetCredentials: resetCredentialsConnect,
});

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const RiskInsightsDirector = connector(RiskInsightsDirectorPresenter);
